module.exports = __webpack_public_path__ + "static/media/IMG-6710.897b50b0.jpg";